import { render } from "./TemplateEngine.vue?vue&type=template&id=669be7cb&ts=true"
import script from "./TemplateEngine.vue?vue&type=script&lang=ts"
export * from "./TemplateEngine.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__